var chunkMapping = {
	"0": [
		4607
	],
	"3": [
		4004,
		4539
	],
	"79": [
		5044
	],
	"164": [
		5131
	],
	"165": [
		5132
	],
	"168": [
		5135
	],
	"169": [
		5136
	],
	"170": [
		5137
	],
	"171": [
		5138
	],
	"172": [
		5139
	],
	"173": [
		5140
	],
	"174": [
		5141
	],
	"175": [
		5142
	],
	"176": [
		5143
	],
	"177": [
		5144
	],
	"178": [
		5145
	],
	"179": [
		5146
	],
	"180": [
		5147
	],
	"181": [
		5148
	],
	"182": [
		5149
	],
	"183": [
		5150
	],
	"184": [
		5151
	],
	"185": [
		5152
	],
	"186": [
		5153
	],
	"187": [
		5154
	]
};
var idToExternalAndNameMapping = {
	"4004": [
		"default",
		"./nuorder-components",
		3687
	],
	"4539": [
		"default",
		"./helios-components",
		3687
	],
	"4607": [
		"default",
		"./Containers",
		3598
	],
	"5044": [
		"default",
		"./OrderlessInvoices",
		3598
	],
	"5131": [
		"default",
		"./AsyncEventTracker",
		3598
	],
	"5132": [
		"default",
		"./HostWrapper",
		3598
	],
	"5135": [
		"default",
		"./CheckoutV3",
		3598
	],
	"5136": [
		"default",
		"./CheckoutConfirmation",
		3598
	],
	"5137": [
		"default",
		"./ContactCreditCards",
		3598
	],
	"5138": [
		"default",
		"./AuditDialog",
		3598
	],
	"5139": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3598
	],
	"5140": [
		"default",
		"./InvoiceDialog",
		3598
	],
	"5141": [
		"default",
		"./PaymentDueModal",
		3598
	],
	"5142": [
		"default",
		"./PaymentModal",
		3598
	],
	"5143": [
		"default",
		"./PaymentHistory",
		3598
	],
	"5144": [
		"default",
		"./PaymentConfigurations",
		3598
	],
	"5145": [
		"default",
		"./PaymentPreferences",
		3598
	],
	"5146": [
		"default",
		"./ManagePaymentProcessing",
		3598
	],
	"5147": [
		"default",
		"./MobilePaymentsWrapper",
		3598
	],
	"5148": [
		"default",
		"./PayPage",
		3598
	],
	"5149": [
		"default",
		"./Challenge",
		3598
	],
	"5150": [
		"default",
		"./ManagePaymentMethods",
		3598
	],
	"5151": [
		"default",
		"./LightspeedReports",
		3598
	],
	"5152": [
		"default",
		"./ActivateLightspeedPayments",
		3598
	],
	"5153": [
		"default",
		"./MarketingLandingPage",
		3598
	],
	"5154": [
		"default",
		"./ShippingPromotionsListContainer",
		3598
	]
};
var idToRemoteMap = {
	"4004": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4539": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3687
		}
	],
	"4607": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5044": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5152": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5153": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	],
	"5154": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3598
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}